interface Props {
  text: string
}

const SettingsLabelText = ({ text }: Props) => {
  return <p className='capitalize font-bold text-base mb-2'>{text}</p>
}

export default SettingsLabelText
